import SelectionState from "state/selections/SelectionState";
import {
  selectBetaDecodes,
  selectDefinitions,
  selectFetchingBetaData,
  selectFetchingBetaSbsData,
} from "./selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectSideBySideValue } from "state/selections/selector";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsBetaData = useSelector(
    selectFetchingBetaData(SummaryType.ABSOLUTE)
  );
  const fetchingRelBetaData = useSelector(
    selectFetchingBetaData(SummaryType.RELATIVE)
  );
  const fetchingAbsBetaSbsData = useSelector(
    selectFetchingBetaSbsData(SummaryType.ABSOLUTE)
  );
  const fetchingRelBetaSbsData = useSelector(
    selectFetchingBetaSbsData(SummaryType.RELATIVE)
  );
  const sideBySide = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED)
  );
  const betaDecodes = useSelector(selectBetaDecodes);
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((colDefs, definition) => {
      const { betaId, covarianceType, covarianceEntity, betaValue, summary } =
        definition;
      const betaEntity = betaDecodes.find((decode) => decode.betaId === betaId);
      const colId = `${betaId}_${covarianceType}_${betaValue}_${summary}`;

      const colDef = {
        headerName: betaEntity
          ? `${betaEntity.betaName}-${covarianceEntity.label} ${definition.betaValue}`
          : `${betaId}-${covarianceEntity.label}`,
        field: colId,
        colId: colId,
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
      if (
        (summary === SummaryType.ABSOLUTE && fetchingAbsBetaData) ||
        (summary === SummaryType.RELATIVE && fetchingRelBetaData)
      ) {
        colDef.loading = true;
      }
      colDefs.push(colDef);

      if (sideBySide) {
        const sbsColDef = { ...colDef };
        sbsColDef.colId += " - scenario";
        sbsColDef.field += " - scenario";
        sbsColDef.headerName += " - scenario";
        sbsColDef.loading =
          (summary === SummaryType.ABSOLUTE && fetchingAbsBetaSbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelBetaSbsData);
        sbsColDef.X_sbs = true;
        sbsColDef.X_originalColId = colId;
        sbsColDef.X_backgroundColor = "#fffb95";
        colDefs.push(sbsColDef);
      }

      return colDefs;
    }, []);
  }, [
    betaDecodes,
    definitions,
    dispatch,
    fetchingAbsBetaData,
    fetchingAbsBetaSbsData,
    fetchingRelBetaData,
    fetchingRelBetaSbsData,
    sideBySide,
  ]);
};
